import { Codes, CodesHash } from '../store/useCodes'
import { useDatabase } from '../composables/database'
import { CodesRows } from '../types/database'
type CodesModelReturn = {
  loadCodes: () => Promise<Codes>
  writeCodes: (data: Codes) => Promise<void>
  clearCodes: () => Promise<void>
  getCodesHashes: () => Promise<CodesHash | undefined>
  writeCodesHashes: (data: CodesHash) => Promise<void>
}
const CODES_TEMPLATE: Codes = {
  rai_codes: [],
  rai_hardware_deductions: [],
  rai_codes_reason_codes: [],
  rai_reason_codes: [],
  rai_codes_visibility: [],
}
export const CodesModel = (): CodesModelReturn => {
  const { run, query } = useDatabase()

  const loadCodes = async () => {
    const sql = 'SELECT * FROM codes WHERE id = 0;'
    return await query(sql)
      .catch((error) => {
        console.log(`Error loading codes: ${error}`)
        return CODES_TEMPLATE
      })
      .then((codes: any) => {
        if (codes && codes.length) {
          const data: Codes = JSON.parse((codes as CodesRows)[0]['codes_data'])
          return data
        } else {
          return CODES_TEMPLATE
        }
      })
  }

  const writeCodes = async (data: Codes) => {
    const sql = `
    INSERT OR REPLACE INTO codes ('id', 'codes_data')
    VALUES (0,?);`
    await run(sql, [JSON.stringify(data)])
  }

  const writeCodesHashes = async (data: CodesHash) => {
    const sql = `
    INSERT OR REPLACE INTO hashes ('key', 'hash')
    VALUES ('codes',?);`
    await run(sql, [JSON.stringify(data)])
  }

  const getCodesHashes = async () => {
    const sql = 'SELECT * FROM hashes WHERE key = "codes"'
    const hashes = await query(sql)

    if (hashes && hashes.length) {
      if (hashes && hashes.length) {
        const data: CodesHash = JSON.parse(hashes[0]['hash'])
        return data
      } else {
        return undefined
      }
    }
  }

  const clearCodes = async () => {
    const sql = 'DELETE FROM codes'
    await run(sql, [])
    const sql_hash = 'DELETE FROM hashes where key = "codes"'
    await run(sql_hash, [])
  }
  return {
    loadCodes,
    writeCodes,
    getCodesHashes,
    writeCodesHashes,
    clearCodes,
  }
}
